import { render, staticRenderFns } from "./CardDashboard.vue?vue&type=template&id=9b6096f0&scoped=true"
import script from "./CardDashboard.vue?vue&type=script&lang=js"
export * from "./CardDashboard.vue?vue&type=script&lang=js"
import style0 from "./CardDashboard.vue?vue&type=style&index=0&id=9b6096f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6096f0",
  null
  
)

export default component.exports